import React, { useEffect, useState } from "react";
import "../styles/NewsTicker.css";

const NewsTicker = () => {
  const [tickerItems, setTickerItems] = useState([]);

useEffect(() => {
  const today = new Date().toISOString().split("T")[0];

  fetch(`${process.env.REACT_APP_NEWS_API_URL}/get-news`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ selected_date: today }),
  })
    .then(res => res.json())
    .then(data => setTickerItems(data))
    .catch(console.error);
}, []);


  if (!tickerItems.length) return null;

  return (
    <div className="news-ticker-container">
      <div className="news-ticker-track">
        {tickerItems.map((item, idx) => (
          <span key={idx} className="news-ticker-item">
            🔔 {item.description}
          </span>
        ))}
      </div>
    </div>
  );
};

export default NewsTicker;
